
<div class="reports-page-wrapper" *ngIf="!isLoading">
    <div class="reports-sidebar card edge-border" [class.reports-sidebar-disabled]="isReportEditorActive()">
        <div class="reports-sidebar-body">
            <div class="reports-sidebar-search">
                <i class="pi pi-search"></i>
                <input pInputText type="text" [(ngModel)]="searchText" placeholder="Search reports..." />
                <button
                    *ngIf="searchText"
                    type="button"
                    class="reports-search-clear-btn"
                    aria-label="Clear search"
                    (click)="searchText = ''">
                    <i class="pi pi-times"></i>
                </button>
            </div>

            <div style="padding-right: 0.65rem;">
                <button
                    type="button"
                    class="reports-sidebar-item favorites-item"
                    [class.selected]="isFavoritesSelected()"
                    (click)="selectCategory('favorites', 'Favorites')">
                    <div>
                        <i class="pi pi-star"></i>
                        <span>Favorites</span>
                    </div>
                    <span class="count-badge">{{ getFavoriteCount() }}</span>
                </button>
            </div>
            
            <div class="reports-divider"></div>

            <div class="reports-sidebar-scroll-region">
                <button
                    type="button"
                    class="reports-sidebar-item"
                    [class.selected]="selectedCategoryKey.toLowerCase() === 'all'"
                    (click)="selectCategory('All', 'All')">
                    <span>All</span>
                    <span class="count-badge">{{ allNavItemCount }}</span>
                </button>

                <ng-container *ngFor="let section of sidebarSections">
                    <div class="section-label section-space">{{ section.label }}</div>
                    <button
                        type="button"
                        class="reports-sidebar-item"
                        *ngFor="let nav of section.navItems"
                        [class.selected]="selectedCategoryKey === nav.id"
                        (click)="selectCategory(nav.id, nav.label)">
                        <span>{{ nav.label }}</span>
                        <span class="count-badge">{{ nav.reportIds.length }}</span>
                    </button>
                    <!-- <div class="reports-divider"></div> -->
                </ng-container>

                <div class="section-label section-space" *ngIf="authService.userSettings?.permissions?.isAdmin">Platform Overview</div>
                <button
                    type="button"
                    class="reports-sidebar-item"
                    *ngIf="authService.userSettings?.permissions?.isAdmin"
                    [class.selected]="isUsageTrackingViewActive"
                    (click)="openUsageTrackingView()">
                    <span>Usage Tracking View</span>
                </button>
            </div>
        </div>

        <div class="reports-divider footer-divider"></div>
        <div class="reports-footer-link" *ngIf="authService.userSettings?.permissions?.isAdmin" (click)="openManageSidebar()">
            <span class="reports-footer-label"><i class="pi pi-list"></i><span>Manage Sidebar</span></span>
        </div>
    </div>

    <div class="reports-main reports-main-list" *ngIf="!selectedReport && !isUsageTrackingViewActive">
        <div class="reports-main-header">
            <div>
                <h3>Reports</h3>
                <p>
                    Select a dashboard to view
                    <button
                        *ngIf="!isSelectedDefaultView()"
                        type="button"
                        class="default-view-text"
                        (click)="setSelectedDefaultCategory()"
                        aria-label="Set as default">
                        Set as default
                    </button>
                    <span *ngIf="isSelectedDefaultView()" class="default-view-text is-active">Default view</span>
                </p>
            </div>
            <div class="reports-main-header-spacer">
                <button
                    *ngIf="!isManageMode && authService.userSettings?.permissions?.isAdmin && selectedCategoryKey.toLowerCase() !== 'all'"
                    type="button"
                    pButton
                    class="manage-reports-btn"
                    label="Manage Reports"
                    icon="pi pi-cog"
                    iconPos="left"
                    (click)="authService.userSettings?.permissions?.isAdmin && (isManageMode = true)"></button>

                <div class="manage-mode-actions" *ngIf="isManageMode">
                    <button type="button" class="manage-mode-btn exit-manage-btn" (click)="isManageMode = false; closeManageSidebar()">
                        <i class="pi pi-cog icon-size"></i>
                        <span>Exit Manage</span>
                    </button>
                    <button type="button" class="manage-mode-btn add-report-btn" (click)="openAddReportDialog()">
                        <i class="pi pi-plus icon-size"></i>
                        <span>Add Report</span>
                    </button>
                </div>
            </div>
        </div>

        <ng-container *ngIf="getFilteredReportCards() as filteredCards">
            <div *ngIf="searchText.trim()" class="reports-search-banner">
                Search results for "{{ searchText.trim() }}" across all categories
            </div>

            <div *ngIf="!filteredCards.length && !isFavoritesSelected()" class="reports-empty text-muted">
                No reports are available.
            </div>

            <div *ngIf="!filteredCards.length && isFavoritesSelected()" class="favorites-empty-state">
                <div class="favorites-empty-icon-wrap">
                    <i class="pi pi-star"></i>
                </div>
                <div class="favorites-empty-title">No favorites yet</div>
                <div class="favorites-empty-text">No favorites yet. Click the star icon on any report to add it here.</div>
            </div>

            <div
                *ngIf="filteredCards.length"
                class="reports-grid"
                [class.reports-grid-compact]="filteredCards.length > 4"
                [class.reports-grid-large]="filteredCards.length <= 4">
                <button
                    type="button"
                    class="report-card"
                    [class.manage-mode]="isManageMode"
                    *ngFor="let card of filteredCards"
                    (click)="!isManageMode && openReportDetail(card)">
                    <div class="report-card-top d-flex align-items-center justify-content-between mb-2">
                        <span class="report-category-badge" *ngIf="card.categoryName">{{ card.categoryName }}</span>
                        <span class="report-card-icons d-flex align-items-center gap-2">
                            <button
                                *ngIf="!isManageMode"
                                type="button"
                                class="report-favorite-btn"
                                [class.is-favorited]="isFavorite(card.id)"
                                [attr.aria-label]="isFavorite(card.id) ? 'Remove from favorites' : 'Add to favorites'"
                                (click)="toggleFavorite(card, $event)">
                                <i class="pi" [class.pi-star]="!isFavorite(card.id)" [class.pi-star-fill]="isFavorite(card.id)"></i>
                                <span class="favorite-tooltip">{{ isFavorite(card.id) ? 'Remove from Favorites' : 'Add to Favorites' }}</span>
                            </button>
                            <button
                                *ngIf="isManageMode"
                                type="button"
                                class="report-card-icon-btn"
                                aria-label="Edit report"
                                (click)="$event.stopPropagation(); openManageReportForCard(card)">
                                <i class="pi pi-pencil"></i>
                            </button>
                            <button
                                *ngIf="isManageMode"
                                type="button"
                                class="report-card-icon-btn"
                                aria-label="Delete report"
                                (click)="$event.stopPropagation(); deleteReportCard(card)">
                                <i class="pi pi-trash"></i>
                            </button>
                        </span>
                    </div>
                    <div class="report-name mb-2">{{ card.reportName }}</div>
                    <div
                        class="report-description w-100"
                        [ngClass]="{ 'is-empty': !card.description || card.description === 'Live dashboard' }">
                        {{ card.description && card.description !== 'Live dashboard' ? card.description : '\u00A0' }}
                    </div>

                    <div class="report-live-row d-flex align-items-center justify-content-between">
                        <span class="report-live-left d-inline-flex align-items-center">
                            <svg class="report-live-icon" [class.report-inactive-icon]="card?.isActive === false" viewBox="0 0 16 16" aria-hidden="true" focusable="false">
                                <path d="M2.2 11.3V7.1M6.1 11.3V4.2M10 11.3V8.6" />
                            </svg>
                            <span>{{ card?.isActive === false ? 'Inactive' : 'Live dashboard' }}</span>
                        </span>
                        <span class="report-open-link d-inline-flex align-items-center" *ngIf="!isManageMode">
                            <span>Open</span>
                            <i class="pi pi-angle-right" aria-hidden="true"></i>
                        </span>
                    </div>
                </button>
            </div>
        </ng-container>
    </div>

    <div class="reports-main reports-main-list" *ngIf="isUsageTrackingViewActive && !selectedReport">
        <div class="reports-main-header">
            <div>
                <h3>Usage Tracking</h3>
            </div>
            
            <div class="usage-tracking-header-actions">

                 <p-calendar 
                    inputId="calendar-12h" 
                    [(ngModel)]="usageTrackingDateRange" 
                    [showTime]="false" 
                    selectionMode="range" 
                    placeholder="Select date range"
                    [showClear]="true"
                    [hourFormat]="12" />
                    
                <div class="usage-tracking-search">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" [(ngModel)]="usageTrackingSearchText" placeholder="Search..." />
                    <button
                        *ngIf="usageTrackingSearchText"
                        type="button"
                        class="reports-search-clear-btn"
                        aria-label="Clear usage tracking search"
                        (click)="usageTrackingSearchText = ''">
                        <i class="pi pi-times"></i>
                    </button>
                </div>
            </div>
        </div>

        <div class="usage-tracking-table-wrapper">
            <table class="usage-tracking-table">
                <colgroup>
                    <col style="width: 2.2em;" />
                    <col />
                    <col style="width: 220px;" />
                    <col style="width: 250px;" />
                </colgroup>
                <thead>
                    <tr>
                        <th style="width: 2.2em;"></th>
                        <th>
                            <button type="button" class="usage-sort-btn" (click)="sortUsageTracking('reportName')">
                                <span>Report Name</span>
                                <i class="p-sortable-column-icon fa" [ngClass]="{
                                    'fa-sort-up': usageTrackingSortField === 'reportName' && usageTrackingSortDirection === 'asc',
                                    'fa-sort-down': usageTrackingSortField === 'reportName' && usageTrackingSortDirection === 'desc',
                                    'fa-sort': usageTrackingSortField !== 'reportName'
                                }"></i>
                            </button>
                        </th>
                        <th class="text-center">
                            <button type="button" class="usage-sort-btn" (click)="sortUsageTracking('count')">
                                <span>Count</span>
                                <i class="p-sortable-column-icon fa" [ngClass]="{
                                    'fa-sort-up': usageTrackingSortField === 'count' && usageTrackingSortDirection === 'asc',
                                    'fa-sort-down': usageTrackingSortField === 'count' && usageTrackingSortDirection === 'desc',
                                    'fa-sort': usageTrackingSortField !== 'count'
                                }"></i>
                            </button>
                        </th>
                        <th class="text-right">
                            <button type="button" class="usage-sort-btn right" (click)="sortUsageTracking('lastVisitedOn')">
                                <span>Last Visited</span>
                                <i class="p-sortable-column-icon fa" [ngClass]="{
                                    'fa-sort-up': usageTrackingSortField === 'lastVisitedOn' && usageTrackingSortDirection === 'asc',
                                    'fa-sort-down': usageTrackingSortField === 'lastVisitedOn' && usageTrackingSortDirection === 'desc',
                                    'fa-sort': usageTrackingSortField !== 'lastVisitedOn'
                                }"></i>
                            </button>
                        </th>
                    </tr>
                </thead>
                <tbody>
                        <ng-container *ngIf="getFilteredUsageTrackingStats() as filteredUsageTrackingStats">
                        <ng-container *ngFor="let report of filteredUsageTrackingStats">
                            <tr class="usage-report-row">
                                <td>
                                    <span class="usage-expand-btn" (click)="expandedUsageReportRows[report.reportId] = !expandedUsageReportRows[report.reportId]">
                                        <i [ngClass]="expandedUsageReportRows[report.reportId] ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></i>
                                    </span>
                                </td>
                                <td>{{ report.reportName }}</td>
                                <td class="text-center">{{ report.count }}</td>
                                <td class="text-right">{{ report.lastVisitedOn | date: 'short' }}</td>
                            </tr>
                            <tr *ngIf="expandedUsageReportRows[report.reportId]">
                                <td [attr.colspan]="4" class="usage-role-cell">
                                    <table class="usage-role-table">
                                        <colgroup>
                                            <col style="width: 2.2em;" />
                                            <col />
                                            <col style="width: 220px;" />
                                            <col style="width: 250px;" />
                                        </colgroup>
                                        <thead>
                                            <tr>
                                                <th style="width: 2.2em;"></th>
                                                <th>Role</th>
                                                <th class="text-center">Count</th>
                                                <th class="text-right">Last Visited</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <ng-container *ngFor="let role of (report.roles || [])">
                                                <tr class="usage-role-row">
                                                    <td>
                                                        <span class="usage-expand-btn" (click)="expandedUsageRoleRows[report.reportId + '_' + role.role] = !expandedUsageRoleRows[report.reportId + '_' + role.role]">
                                                            <i class="pi" [ngClass]="expandedUsageRoleRows[report.reportId + '_' + role.role] ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
                                                        </span>
                                                    </td>
                                                    <td>{{ role.roleName }}</td>
                                                    <td class="text-center">{{ role.count }}</td>
                                                    <td class="text-right">{{ role.lastVisitedOn | date: 'short' }}</td>
                                                </tr>
                                                <tr *ngIf="expandedUsageRoleRows[report.reportId + '_' + role.role]">
                                                    <td [attr.colspan]="4" class="usage-user-cell">
                                                        <table class="usage-user-table">
                                                            <colgroup>
                                                                <col style="width: 2.2em;" />
                                                                <col />
                                                                <col style="width: 220px;" />
                                                                <col style="width: 250px;" />
                                                            </colgroup>
                                                            <thead>
                                                                <tr>
                                                                    <th></th>
                                                                    <th>Full Name</th>
                                                                    <th class="text-center">Count</th>
                                                                    <th class="text-right">Last Visited</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr *ngFor="let user of (role.users || [])">
                                                                    <td></td>
                                                                    <td>{{ user.userName }}</td>
                                                                    <td class="text-center">{{ user.count }}</td>
                                                                    <td class="text-right">{{ user.lastVisitedOn | date: 'short' }}</td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </td>
                                                </tr>
                                                <tr *ngIf="!(role.users || []).length && expandedUsageRoleRows[report.reportId + '_' + role.role]">
                                                    <td [attr.colspan]="4" class="usage-user-empty">No users found for this role</td>
                                                </tr>
                                            </ng-container>
                                        </tbody>
                                    </table>
                                </td>
                            </tr>
                        </ng-container>
                        <tr *ngIf="!filteredUsageTrackingStats.length">
                            <td colspan="4" class="usage-tracking-empty">No usage data available</td>
                        </tr>
                        </ng-container>
                </tbody>
            </table>
        </div>
    </div>

    <div class="reports-main reports-main-detail" *ngIf="selectedReport && !isUsageTrackingViewActive">
        <div class="report-breadcrumb-row">
            <button type="button" class="breadcrumb-link" (click)="backToGrid()">Reports</button>
            <span class="breadcrumb-separator">&gt;</span>
            <span class="breadcrumb-current">{{ selectedReport.reportName }}</span>
            <span class="report-category-badge detail" *ngIf="selectedReport.categoryName">{{ selectedReport.categoryName }}</span>
        </div>
        <hr>

        <div class="report-detail-empty" *ngIf="!(selectedReport.embedCode || '').trim()">
            <div class="empty-title">Dashboard not configured</div>
            <div class="empty-text">This report does not have a URL or embed code yet.</div>
        </div>

        <div class="report-embed-wrapper" *ngIf="!!(selectedReport.embedCode || '').trim() && shouldRenderTableauViz()">
            <div #tableauHost class="report-tableau-host"></div>
        </div>

        <div class="report-embed-wrapper" *ngIf="!!(selectedReport.embedCode || '').trim() && shouldRenderIframe()">
            <iframe
                class="report-iframe"
                [src]="selectedReportSafeSrc"
                frameborder="0"
                style="border:0"
                allowfullscreen
                loading="lazy"
                referrerpolicy="strict-origin-when-cross-origin"
                (error)="iframeLoadError = 'Unable to load embedded dashboard. Please verify the embed URL and sharing permissions.'"
                sandbox="allow-storage-access-by-user-activation allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox">
            </iframe>
        </div>

        <div class="report-detail-empty tableau-error" *ngIf="!!(selectedReport.embedCode || '').trim() && shouldRenderIframe() && iframeLoadError">
            <div class="empty-title">Unable to load this dashboard</div>
            <div class="empty-text">{{ iframeLoadError }}</div>
        </div>

        <div class="report-detail-empty tableau-error" *ngIf="!!(selectedReport.embedCode || '').trim() && shouldRenderTableauViz() && tableauLoadError">
            <div class="empty-title">Unable to load this dashboard</div>
            <div class="empty-text">{{ tableauLoadError }}</div>
            <div class="empty-text">If the message includes 401 Unauthorized, your Tableau session is not authenticated for this environment.</div>
        </div>
    </div>
</div>

<div class="reports-default-view-toast" *ngIf="showDefaultViewToast && !selectedReport">
    Selected default category: "{{ selectedDefaultCategoryName }}"
</div>

<div class="manage-sidebar-overlay" *ngIf="isManageSidebarOpen && authService.userSettings?.permissions?.isAdmin">
    <div class="manage-sidebar-dialog edge-border">
        <div class="manage-sidebar-header">
            <div>
                <div class="manage-sidebar-title">Manage Sidebar</div>
                <div class="manage-sidebar-subtitle">Select a section to view and edit its reports</div>
            </div>
            <button type="button" class="manage-close-btn" (click)="closeManageSidebar()">&times;</button>
        </div>

        <div class="manage-sidebar-content">
            <aside class="manage-section-list" [class.manage-section-list-disabled]="isReportEditorActive()">
                <button
                    type="button"
                    class="manage-section-item"
                    [class.selected]="selectedManageSectionKey === 'all-sections'"
                    (click)="selectManageAll()">
                    <span class="manage-section-title">All</span>
                    <i class="pi pi-angle-right manage-section-arrow" *ngIf="selectedManageSectionKey !== 'all-sections'"></i>
                </button>

                <div class="manage-section-scroll">

                <ng-container *ngFor="let section of defaultManageSections">
                    <button
                        type="button"
                        class="manage-section-item"
                        (click)="selectManageSection(section.key)">
                        <span class="manage-section-title" *ngIf="editingSectionKey !== section.key">
                            <svg *ngIf="section.isLocked" class="manage-lock-icon" viewBox="0 0 16 16" aria-hidden="true" focusable="false">
                                <path d="M4.5 7V5.2a3.5 3.5 0 1 1 7 0V7" />
                                <rect x="3" y="7" width="10" height="7" rx="1.6" />
                            </svg>
                            {{ section.label }}
                        </span>
                        <span class="manage-section-edit-wrap" *ngIf="editingSectionKey === section.key" (click)="$event.stopPropagation()">
                            <input
                                type="text"
                                class="manage-inline-input"
                                [(ngModel)]="editingSectionDraft"
                                (keydown.enter)="saveEditManageSection(section.key)"
                                maxlength="60" />
                            <button type="button" class="manage-inline-action" (click)="saveEditManageSection(section.key)">
                                <i class="pi pi-check"></i>
                            </button>
                            <button type="button" class="manage-inline-action" (click)="cancelEditManageSection()">
                                <i class="pi pi-times"></i>
                            </button>
                        </span>
                        <span class="manage-section-side-actions" *ngIf="editingSectionKey !== section.key">
                            <button
                                *ngIf="selectedManageSectionKey === section.key && !section.isLocked && !isManageReportMode"
                                type="button"
                                class="manage-inline-action"
                                (click)="$event.stopPropagation(); startEditManageSection(section.key)">
                                <i class="pi pi-pencil"></i>
                            </button>
                            <i class="pi pi-angle-right manage-section-arrow" *ngIf="selectedManageSectionKey !== section.key || (section.key === 'campaign-type' && selectedManageSectionKey === 'all-sections')"></i>
                        </span>
                    </button>

                    <div class="manage-section-children-preview" *ngIf="section.visibleNavItems.length">
                        <div class="manage-section-child-preview" *ngFor="let nav of section.visibleNavItems" [class.selected]="selectedCategoryId === nav.id">
                            <span>{{ nav.label }}</span>
                            <span class="count-badge">{{ nav.reportIds.length }}</span>
                        </div>
                    </div>
                </ng-container>

                <div class="manage-custom-label">CUSTOM</div>

                <ng-container *ngFor="let section of customManageSections">
                    <button
                        type="button"
                        class="manage-section-item"
                        (click)="selectManageSection(section.key)">
                        <span class="manage-section-title-custom" *ngIf="editingSectionKey !== section.key">
                            <span class="manage-nav-caret-stack" *ngIf="!section.isLocked && !isManageReportMode">
                                <button
                                    type="button"
                                    class="manage-nav-order-btn"
                                    (click)="$event.preventDefault(); $event.stopPropagation(); moveNavItem(section.key, section.key, -1)">
                                    <i class="pi pi-caret-up manage-nav-icon"></i>
                                </button>
                                <button
                                    type="button"
                                    class="manage-nav-order-btn"
                                    (click)="$event.preventDefault(); $event.stopPropagation(); moveNavItem(section.key, section.key, 1)">
                                    <i class="pi pi-caret-down manage-nav-icon"></i>
                                </button>
                            </span>
                            {{ section.label }}
                            <svg *ngIf="section.isLocked" class="manage-lock-icon" viewBox="0 0 16 16" aria-hidden="true" focusable="false">
                                <path d="M4.5 7V5.2a3.5 3.5 0 1 1 7 0V7" />
                                <rect x="3" y="7" width="10" height="7" rx="1.6" />
                            </svg>
                        </span>
                        <span class="manage-section-edit-wrap" *ngIf="editingSectionKey === section.key" (click)="$event.stopPropagation()">
                            <input
                                type="text"
                                class="manage-inline-input"
                                [(ngModel)]="editingSectionDraft"
                                (keydown.enter)="saveEditManageSection(section.key)"
                                maxlength="60" />
                            <button type="button" class="manage-inline-action" (click)="saveEditManageSection(section.key)">
                                <i class="pi pi-check"></i>
                            </button>
                            <button type="button" class="manage-inline-action" (click)="cancelEditManageSection()">
                                <i class="pi pi-times"></i>
                            </button>
                        </span>
                        <span class="manage-section-side-actions" *ngIf="editingSectionKey !== section.key">
                            <button
                                *ngIf="selectedManageSectionKey === section.key && !section.isLocked && !isManageReportMode"
                                type="button"
                                class="manage-inline-action"
                                (click)="$event.stopPropagation(); startEditManageSection(section.key)">
                                <i class="pi pi-pencil"></i>
                            </button>
                            <button
                                *ngIf="selectedManageSectionKey === section.key && !section.isLocked && !isManageReportMode"
                                type="button"
                                class="manage-inline-action"
                                (click)="$event.stopPropagation(); deleteManageSection(section.key)">
                                <i class="pi pi-trash"></i>
                            </button>
                            <i class="pi pi-angle-right manage-section-arrow" *ngIf="selectedManageSectionKey !== section.key"></i>
                        </span>
                    </button>

                    <div class="manage-section-children-preview" *ngIf="section.visibleNavItems.length">
                        <div class="manage-section-child-preview" *ngFor="let nav of section.visibleNavItems" [class.selected]="selectedCategoryId === nav.id">
                            <span>{{ nav.label }}</span>
                            <span class="count-badge">{{ nav.reportIds.length }}</span>
                        </div>
                    </div>
                </ng-container>

                </div>

                <div class="manage-section-item" *ngIf="isAddingSection && !isManageReportMode">
                    <span class="manage-section-edit-wrap manage-new-section-row" (click)="$event.stopPropagation()">
                        <input
                            type="text"
                            class="manage-inline-input"
                            [(ngModel)]="newSectionDraft"
                            placeholder="Section name"
                            (keydown.enter)="confirmAddManageSection()"
                            maxlength="60" />
                        <button type="button" class="manage-inline-action" (click)="confirmAddManageSection()">
                            <i class="pi pi-check"></i>
                        </button>
                        <button type="button" class="manage-inline-action" (click)="isAddingSection = false; newSectionDraft = ''">
                            <i class="pi pi-times"></i>
                        </button>
                    </span>
                </div>

                <div class="manage-section-add-wrap" *ngIf="!isManageReportMode">
                    <button *ngIf="!isAddingSection" type="button" class="manage-section-add" (click)="isAddingSection = true; newSectionDraft = ''">+ Add Section</button>
                </div>
            </aside>

            <section class="manage-form-panel">
                <header class="manage-form-header" *ngIf="selectedManageSectionKey === 'all-sections'">
                    <div>
                        <div class="manage-title-row">
                            <h3>All</h3>
                        </div>
                        <div class="manage-header-subtitle">All sections and nav items</div>
                    </div>
                </header>

                <header class="manage-form-header" *ngIf="getSelectedManageSectionView() as section">
                    <div>
                        <div class="manage-title-row">
                            <svg *ngIf="section.isLocked" class="manage-title-lock" viewBox="0 0 16 16" aria-hidden="true" focusable="false">
                                <path d="M4.5 7V5.2a3.5 3.5 0 1 1 7 0V7" />
                                <rect x="3" y="7" width="10" height="7" rx="1.6" />
                            </svg>
                            <h3>{{ section.label }}</h3>
                        </div>
                        <div class="manage-header-subtitle" *ngIf="section.key === 'campaign-type'">{{ section.navItems.length }} nav item{{ section.navItems.length === 1 ? '' : 's' }}</div>
                        <div class="manage-header-subtitle" *ngIf="section.kind === 'custom'">{{ section.navItems.length }} nav item{{ section.navItems.length === 1 ? '' : 's' }}</div>
                    </div>
                </header>

                <div class="manage-empty-panel" *ngIf="!getSelectedManageSectionView() && selectedManageSectionKey !== 'all-sections'">
                    Select a section
                </div>

                <component-loader-spinner [isLoading]="isManageOrderLoading"></component-loader-spinner>

                <div class="manage-hierarchy" *ngIf="selectedManageSectionKey === 'all-sections' && !isManageReportMode">
                    <div class="manage-nav-row" *ngFor="let section of manageSections">
                        <div class="manage-nav-header">
                            <div class="manage-nav-title manage-active-nav-title">
                                <span>{{ section.label }}</span>
                            </div>
                        </div>

                        <div class="manage-nav-row" *ngFor="let nav of section.visibleNavItems">
                            <div class="manage-nav-header">
                                <div class="manage-nav-title">
                                    <span>{{ nav.label }}</span>
                                </div>
                            </div>

                            <ng-container *ngIf="nav.reports as navReports">
                                <div class="manage-report-list" *ngIf="navReports.length; else noReportsTemplateAll">
                                    <div class="manage-report-item" *ngFor="let report of navReports">
                                        <div class="manage-report-text">
                                            <div class="manage-report-name">
                                                <svg class="manage-report-icon" viewBox="0 0 16 16" aria-hidden="true" focusable="false">
                                                    <path d="M2.2 11.3V7.1M6.1 11.3V4.2M10 11.3V8.6" />
                                                </svg>
                                                <span>{{ report.reportName }}</span>
                                            </div>
                                            <div class="manage-report-subtitle" *ngIf="report.description && report.description !== 'Live dashboard'">
                                                {{ report.description }}
                                            </div>
                                        </div>
                                        <div class="manage-report-meta">
                                            <div class="manage-report-state">URL set</div>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                    </div>

                    <ng-template #noReportsTemplateAll>
                        <div class="manage-no-report">No reports assigned</div>
                    </ng-template>
                </div>

                <div class="manage-hierarchy" *ngIf="getSelectedManageSectionView() as section">
                    <ng-container *ngIf="isManageReportMode; else manageSidebarDefaultView">
                        <div class="manage-nav-row manage-report-editor" *ngIf="getSelectedManageNavView() as nav; else noNavTemplate">
                            <div class="manage-nav-header">
                                <div class="manage-nav-title manage-active-nav-title">
                                    <span>{{ isCreatingReport ? 'ADD REPORT' : nav.label }}</span>
                                </div>
                            </div>

                            <div class="manage-report-edit-card" [formGroup]="manageReportForm" *ngIf="getSelectedManageReportView() || isCreatingReport; else noReportsTemplateManage">
                                <div class="form-group mb-3">
                                    <label class="font-weight-bold">Name <span class="text-danger">*</span></label>
                                    <input type="text" class="form-control" maxlength="120" formControlName="name" />
                                </div>

                                <div class="form-group mb-3">
                                    <label class="font-weight-bold">Category</label>
                                    <select
                                        class="form-control"
                                        formControlName="category"
                                        (change)="selectedCategoryId = manageReportForm.controls['category'].value;">
                                        <option *ngFor="let category of manageReportCategoryOptions" [ngValue]="category.id">{{ category.label }}</option>
                                    </select>
                                </div>

                                <div class="form-group mb-3">
                                    <label class="font-weight-bold">Description</label>
                                    <textarea class="form-control" rows="2" maxlength="90" formControlName="description"></textarea>
                                </div>

                                <div class="form-group mb-3">
                                    <label class="font-weight-bold pr-2">Embed Type</label>
                                    <div class="manage-embed-type-toggle">
                                        <button
                                            type="button"
                                            class="manage-embed-toggle-btn"
                                            [class.selected]="manageEmbedType === 'url'"
                                            (click)="setManageEmbedType('url')">
                                            URL
                                        </button>
                                        <button
                                            type="button"
                                            class="manage-embed-toggle-btn"
                                            [class.selected]="manageEmbedType === 'code'"
                                            (click)="setManageEmbedType('code')">
                                            Embed Code
                                        </button>
                                    </div>
                                </div>

                                <div class="form-group mb-3">
                                    <label class="font-weight-bold">{{ manageEmbedType === 'url' ? 'URL' : 'Embed Code' }}</label>
                                    <textarea
                                        class="form-control"
                                        rows="4"
                                        formControlName="source"
                                        ></textarea>
                                </div>

                                <div class="form-group mb-3">
                                    <label class="font-weight-bold">Visible to Roles <span class="text-danger">*</span></label>
                                    <p-multiSelect
                                        [placeholder]="'Choose'"
                                        [options]="roleOptions"
                                        optionLabel="label"
                                        optionValue="id"
                                        formControlName="visibleRoleIds"
                                        appendTo="body"
                                        [autoZIndex]="true"
                                        [baseZIndex]="1300"
                                        [filter]="true"
                                        [virtualScroll]="true"
                                        [showToggleAll]="true"
                                        scrollHeight="220px"
                                        [itemSize]="30"
                                        selectedItemsLabel="{0} items selected"
                                        [style]="{width: '100%'}"
                                        autoWidth="false"></p-multiSelect>
                                </div>

                                <div class="manage-active-row">
                                    <input id="reportActive" type="checkbox" formControlName="isActive" />
                                    <label for="reportActive" class="mb-0">Active</label>
                                </div>

                                <div class="manage-report-actions">
                                    <button
                                        type="button"
                                        pButton
                                        class="manage-report-save-btn"
                                        label="Save"
                                        [disabled]="isManageReportSaveDisabled()"
                                        (click)="UpdateReport()"></button>
                                    <button type="button" class="manage-report-cancel-btn" (click)="cancelManageReportEdit()">
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </div>

                        <ng-template #noNavTemplate>
                            <div class="manage-no-report">No nav items available</div>
                        </ng-template>

                        <ng-template #noReportsTemplateManage>
                            <div class="manage-no-report">No reports assigned</div>
                        </ng-template>
                    </ng-container>

                    <ng-template #manageSidebarDefaultView>
                        <div class="manage-custom-nav-header" *ngIf="!section.isLocked">
                            <span class="manage-nav-items-label">NAV ITEMS</span>
                            <button type="button" class="manage-add-nav-link" (click)="startAddNavItem(section.key)">+ Add Nav Item</button>
                        </div>

                        <div class="manage-section-edit-wrap manage-new-nav-row" *ngIf="addingNavForSectionKey === section.key">
                            <input
                                type="text"
                                class="manage-inline-input"
                                [(ngModel)]="newNavDraft"
                                placeholder="Nav item name"
                                (keydown.enter)="confirmAddNavItem(section.key)"
                                maxlength="60" />
                            <button type="button" class="manage-inline-action" (click)="confirmAddNavItem(section.key)">
                                <i class="pi pi-check"></i>
                            </button>
                            <button type="button" class="manage-inline-action" (click)="addingNavForSectionKey = ''; newNavDraft = ''">
                                <i class="pi pi-times"></i>
                            </button>
                        </div>

                        <div class="manage-nav-row" *ngFor="let nav of section.visibleNavItems">
                            <div class="manage-nav-header">
                                <div class="manage-nav-title" *ngIf="editingNavId !== nav.id">
                                    <span class="manage-nav-caret-stack" *ngIf="section.key !== 'campaign-type'">
                                        <button
                                            type="button"
                                            class="manage-nav-order-btn"
                                            (click)="$event.preventDefault(); $event.stopPropagation(); moveNavItem(section.key, nav.id, -1)">
                                            <i class="pi pi-caret-up manage-nav-icon"></i>
                                        </button>
                                        <button
                                            type="button"
                                            class="manage-nav-order-btn"
                                            (click)="$event.preventDefault(); $event.stopPropagation(); moveNavItem(section.key, nav.id, 1)">
                                            <i class="pi pi-caret-down manage-nav-icon"></i>
                                        </button>
                                    </span>
                                    <span>{{ nav.label }}</span>
                                </div>
                                <div class="manage-section-edit-wrap" *ngIf="editingNavId === nav.id" (click)="$event.stopPropagation()">
                                    <input
                                        type="text"
                                        class="manage-inline-input"
                                        [(ngModel)]="editingNavDraft"
                                        (keydown.enter)="saveEditNavItem(section.key, nav.id)"
                                        maxlength="60" />
                                    <button type="button" class="manage-inline-action" (click)="saveEditNavItem(section.key, nav.id)">
                                        <i class="pi pi-check"></i>
                                    </button>
                                    <button type="button" class="manage-inline-action" (click)="cancelEditNavItem()">
                                        <i class="pi pi-times"></i>
                                    </button>
                                </div>
                                <div class="manage-section-side-actions manage-nav-row-actions" *ngIf="!section.isLocked && editingNavId !== nav.id">
                                    <button
                                        type="button"
                                        class="manage-inline-action"
                                        (click)="startEditNavItem(section.key, nav.id)">
                                        <i class="pi pi-pencil"></i>
                                    </button>
                                    <button
                                        type="button"
                                        class="manage-inline-action"
                                        (click)="deleteNavItem(section.key, nav.id)">
                                        <i class="pi pi-trash"></i>
                                    </button>
                                </div>
                            </div>

                            <ng-container *ngIf="nav.reports as navReports">
                                <div
                                    class="manage-report-list"
                                    *ngIf="navReports.length; else noReportsTemplate"
                                    (dragover)="$event.preventDefault()"
                                    (drop)="onManageReportDropToNavEnd($event, nav.id)">
                                    <ng-container *ngFor="let report of navReports">
                                    <div
                                        class="manage-report-item"
                                        [attr.id]="'manage-report-' + report.id"
                                        draggable="true"
                                        (click)="authService.userSettings?.permissions?.isAdmin ? openManageReportFromSidebar(section.key, nav.id, report) : null"
                                        (dragstart)="onManageReportDragStart($event, nav.id, report.id)"
                                        (dragend)="clearManageDragState()"
                                        (dragover)="$event.preventDefault()"
                                        (drop)="onManageReportDrop($event, nav.id, report.id)">
                                        <div class="manage-report-text">
                                            <div class="manage-report-name">
                                                <svg class="manage-report-icon" viewBox="0 0 16 16" aria-hidden="true" focusable="false">
                                                    <path d="M2.2 11.3V7.1M6.1 11.3V4.2M10 11.3V8.6" />
                                                </svg>
                                                <span>{{ report.reportName }}</span>
                                            </div>
                                            <div class="manage-report-subtitle" *ngIf="report.description && report.description !== 'Live dashboard'">
                                                {{ report.description }}
                                            </div>
                                        </div>
                                        <div class="manage-report-meta">
                                            <div class="manage-report-state">URL set</div>
                                            <div class="manage-report-row-actions" *ngIf="authService.userSettings?.permissions?.isAdmin" (mousedown)="$event.preventDefault(); $event.stopPropagation()" (click)="$event.stopPropagation()">
                                                <button
                                                    type="button"
                                                    class="manage-inline-action"
                                                    draggable="false"
                                                    (mousedown)="$event.preventDefault(); $event.stopPropagation()"
                                                    (click)="$event.preventDefault(); $event.stopPropagation(); openManageReportFromSidebar(section.key, nav.id, report)">
                                                    <i class="pi pi-pencil"></i>
                                                </button>
                                                <button
                                                    type="button"
                                                    class="manage-inline-action"
                                                    draggable="false"
                                                    (mousedown)="$event.preventDefault(); $event.stopPropagation()"
                                                    (click)="$event.preventDefault(); $event.stopPropagation(); deleteReportFromSidebar(section.key, nav.id, report)">
                                                    <i class="pi pi-trash"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="manage-report-edit-card manage-inline-report-edit-card" [formGroup]="manageReportForm" *ngIf="isInlineManageReportEdit && selectedManageReportId === report.id">
                                        <div class="form-group mb-3">
                                            <label class="font-weight-bold">Name</label>
                                            <input type="text" class="form-control" maxlength="120" formControlName="name" />
                                        </div>

                                        <div class="form-group mb-3">
                                            <label class="font-weight-bold">Description</label>
                                            <textarea class="form-control" rows="2" maxlength="90" formControlName="description"></textarea>
                                        </div>

                                        <div class="form-group mb-3">
                                            <label class="font-weight-bold">Tableau URL</label>
                                            <textarea
                                                class="form-control"
                                                rows="3"
                                                formControlName="source"
                                                ></textarea>
                                        </div>

                                        <div class="manage-active-row">
                                            <input id="reportActiveInline" type="checkbox" formControlName="isActive" />
                                            <label for="reportActiveInline" class="mb-0">Active</label>
                                        </div>

                                        <div class="manage-report-actions">
                                            <button
                                                type="button"
                                                pButton
                                                class="manage-report-save-btn"
                                                label="Save"
                                                [disabled]="isManageReportSaveDisabled()"
                                                (click)="UpdateReport()"></button>
                                            <button type="button" class="manage-report-cancel-btn" (click)="cancelManageReportEdit()">
                                                Cancel
                                            </button>
                                        </div>
                                    </div>
                                    </ng-container>
                                </div>
                            </ng-container>
                        </div>

                        <ng-template #noReportsTemplate>
                            <div class="manage-no-report">No reports assigned</div>
                        </ng-template>
                    </ng-template>
                </div>
            </section>
        </div>
    </div>

</div>

<p-confirmDialog
    header="Confirmation"
    icon="pi pi-exclamation-triangle"
    key="reportsDelete"
    appendTo="body"
    [autoZIndex]="true"
    [baseZIndex]="20000"
    acceptButtonStyleClass="p-button-primary"
    rejectButtonStyleClass="p-button-secondary">
</p-confirmDialog>
